<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "UmanjeniSatBase"
};
</script>

<style scoped>

</style>
